import apiConfig from "@config/api.json";
import { HttpStatusCode } from "axios";
import { inject, injectable } from "inversify";
import type { DateTime } from "luxon";
import MeasurementService from "@/src/application/services/measurement-service";
import type MeasurementResponse from "@/src/domain/models/measurement-response";
import type PaginatedFlowMeasurementResponse from "@/src/domain/models/paginated-flow-measurement-response";
import { MeasurementV2ControllerApi } from "@generated/n3-backend-api/n3-backend-open-api-gen/measurement-v2-controller-api";
import { BusinessException } from "@/src/domain/common/business-exception";

@injectable()
export default class MeasurementServiceImpl extends MeasurementService {
  constructor(
    @inject(MeasurementV2ControllerApi)
    private readonly measurementApi: MeasurementV2ControllerApi
  ) {
    super();
  }

  async fetchTotalFlowMeasurement(deviceId: number) {
    const res = await this.measurementApi.totalFlow(deviceId);
    return res.data;
  }

  async fetchPaginatedFlowMeasurements(
    deviceId: number,
    startDate: DateTime,
    endDate: DateTime,
    currentPage: number
  ): Promise<PaginatedFlowMeasurementResponse> {
    const res = await this.measurementApi.intervalFlowData(
      deviceId,
      startDate.toUTC().toISO()!,
      endDate.toUTC().toISO()!,
      apiConfig.request.defaultPageSize,
      currentPage
    );
    if (res.status != HttpStatusCode.Ok)
      throw new BusinessException("Failed to get interval flow measurement");
    return res.data;
  }
}
